import type { CustomShape } from './types';

const shape: CustomShape = {
  borderRadius: 8,
};

export default shape;
